module.exports = {"522702001":"金山街道","522702002":"马场坪街道","522702102":"凤山镇","522702103":"陆坪镇","522702105":"龙昌镇","522702106":"牛场镇","522702107":"道坪镇","522702203":"仙桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522702.json
// module id = 2661
// module chunks = 0